// detectTheme.js
const themes = [
  {
    regex: /(dailytelegraph|couriermail|adelaidenow|heraldsun|thechronicle|goldcoastbulletin|geelongadvertiser)(?:sit|uat)?.com.au/,
    value: 'bob',
    loadCSS: () => import('./bob.scss')
  },
  {
    regex: /(ntnews|cairnspost|townsvillebulletin|themercury|weeklytimesnow)(?:sit|uat)?.com.au/,
    value: 'mhr',
    loadCSS: () => import('./mhr.scss')
  },
  {
    regex: /\.(news)(?:sit|uat)?.com.au/,
    value: 'news',
    loadCSS: () => import('./news.scss')
  },
  {
    regex: /(theaustralian)(?:sit|uat)?.com.au/,
    value: 'theaustralian',
    loadCSS: () => import('./theaustralian.scss')
  },
  {
    regex: /(skynews|sn)(?:sit|uat)?.com.au/,
    value: 'skynews',
    loadCSS: () => import('./skynews.scss')
  },
  //{
  //  regex: /(novo)(?:sit|uat)?.com.au/,
  //  value: 'sport',
  //  loadCSS: () => import('./sport.scss')
  // },
  {
    regex: /(escape)(?:sit|uat)?.com.au/,
    value: 'escape',
    loadCSS: () => import('./escape.scss')
  },
  {
    regex: /(kidsnews)(?:sit|uat)?.com.au/,
    value: 'kidsnews',
    loadCSS: () => import('./kidsnews.scss')
  },
  {
    regex: /(kidspot)(?:sit|uat)?.com.au/,
    value: 'kidspot',
    loadCSS: () => import('./kidspot.scss')
  },
  {
    regex: /(bodyandsoul)(?:sit|uat)?.com.au/,
    value: 'bodyandsoul',
    loadCSS: () => import('./bodyandsoul.scss')
  },
  {
    regex: /(?:(?:sit|uat).)?(taste).com.au/,
    value: 'taste',
    loadCSS: () => import('./taste.scss')
  },
  {
    regex: /(?:(?:sit|uat).)?(delicious).com.au/,
    value: 'delicious',
    loadCSS: () => import('./delicious.scss')
  },
  {
    regex: /(bestrecipes.com.au|elb.web.br.uat.nlm.io)/,
    value: 'bestrecipes',
    loadCSS: () => import('./bestrecipes.scss')

  },
  {
    regex: /(gq)(?:sit|uat)?.com.au/,
    value: 'gq',
    loadCSS: () => import('./gq.scss')
  },
  {
    regex: /(vogue)(?:sit|uat)?.com.au/,
    value: 'vogue',
    loadCSS: () => import('./vogue.scss')
  },
  {
    regex: /(codesports)(?:sit|uat)?.com.au/,
    value: 'codesports',
    loadCSS: () => import('./codesports.scss')
  },
];

function detectTheme(url) {
  console.groupCollapsed('detectTheme', themes, url);
  for (const themeConfig of themes) {
    if (themeConfig.regex.test(url)) {
      console.log('match theme', themeConfig.value);
      console.groupEnd();
      return themeConfig.value;
    }
  }
  console.groupEnd();
  return 'core';
}

export function loadThemeCSS(theme) {
  const config = themes.find( t => t.value === theme);
  console.log('loadThemeCSS', theme, config);
  if (config && typeof config.loadCSS === 'function') {
    console.log('theme has loadCSS function');
    config.loadCSS();
  }

}


export default detectTheme;
export const themeNames = [ 'core' ].concat(themes.map(t => t.value));

// // loader.js
// const url = window.AMP_ENV ? window.AMP_ENV.capiUrl : window.location.href;
// const theme = detectTheme(url);
